import { render } from "./FreeShippingProgress.vue?vue&type=template&id=65192084&scoped=true"
import script from "./FreeShippingProgress.vue?vue&type=script&lang=js"
export * from "./FreeShippingProgress.vue?vue&type=script&lang=js"

import "./FreeShippingProgress.vue?vue&type=style&index=0&id=65192084&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65192084"]])

export default __exports__